namespace $.$$ {
	export class $eve_app_page_components_avatar extends $.$eve_app_page_components_avatar {}
}
